<div class="grid grid-cols-2 gap-4 gap-x-8 mb-2">
  <app-blocked-dates *ngFor="let line of quadrantLines" [quadrantLinesBlocked]="line"></app-blocked-dates>
</div>

<app-community-blocked-form #blockedForm (onSubmitSend)="onCreate($event)"></app-community-blocked-form>
